export const scrollToElement = (e: Element, topOffset: number) => {
  window.scrollTo({
    top: e.getBoundingClientRect().top + window.scrollY + topOffset,
  })
}
